<div class="bg-white">
  <table class="dc-table">
    <tbody>
      <tr>
        <td  class="w-70 py-4!">
         {{ "ACCOUNT.YOUR_ROLE" | translate}}
        </td>
        <td class="text-dc-navy! font-semibold!">{{userAccessData && userAccessData["DC User Type"] ? userAccessData["DC User Type"] : '-'}}</td>
      </tr>
      <tr>
        <td  class="w-70 py-4!">
          {{"ACCOUNT.ACCESS_LEVEL" |  translate}}
        </td>
        <td class="text-dc-navy! font-semibold!">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
            @for (s of accessableServices; track $index) {
            <label
              class="flex items-center gap-x-2 relative cursor-default select-none pointer-events-none"
              aria-disabled="true"
            >
              <input
                type="checkbox"
                [checked]="s.checked"
                tabindex="-1"
                class="peer form-checkbox h-6 w-6 rounded-none border-dc-navy accent-dc-navy"
              />

              <!-- Custom check mark -->
              @if (s.checked) {
              <span
                class="h-6 w-6 absolute text-white text-sm text-center bg-dc-navy border border-dc-navy"
              >
                <i class="fas fa-check"></i>
              </span>
              }

              <span
                class="text-sm whitespace-nowrap"
                [class.text-dc-navy]="s.checked"
                [class.text-gray-400]="!s.checked"
              >
                {{ s.label }}
              </span>
            </label>
            }
          </div>
        </td>
      </tr>
      <tr>
        <td  class="w-70 py-4!">
          {{"ACCOUNT.ACCESS_STARTING_TIME" |  translate}}
        </td>
        <td class="text-dc-navy! font-semibold! py-4!">
          
          {{ this.userAccessData['DC Access Start Time'] ? (this.userAccessData['DC Access Start Time'] | date : "dd-MMMM-yyyy hh:mm" ) : "-"}}</td>
      </tr>
    </tbody>
  </table>

  <!-- action buttons -->
   <div class="flex flex-col sm:flex-row sm:flex-wrap gap-3 mt-6">
    <app-button
      [label]="'BUTTONS.DELINK' | translate"
      classesName="card-edge-cut-white btn-primary-big w-full sm:w-auto"
      (onBtnClick)="unLinkMember()"
    >
    </app-button>
  </div>
</div>
